import {
  children,
  field,
  immutableRelation,
  text,
} from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";
import { Query, Relation } from "@nozbe/watermelondb";
import Product from "./Product";
import ProductKitItem from "./ProductKitItem";
import { Associations } from "@nozbe/watermelondb/Model";

export default class ProductKit extends BaseModel {
  static table = "product_kits";

  static associations: Associations = {
    product_kit_items: { type: "has_many", foreignKey: "product_kit_id" },
  };

  @immutableRelation("products", "product_id") product: Relation<Product>;

  @field("kit_id") kitId: string;

  @text("description") description: string | null;

  @field("price") price: number;

  @children("product_kit_items")
  items: Query<ProductKitItem>;
}
